import { Outlet } from 'react-router-dom';

const IndexLayout = () => {
	return (
		<main className="index-layout-wrapper" style={{ minHeight: '100vh', width: '100%', overflow: 'hidden' }}>
			<Outlet />
		</main>
	);
};

export default IndexLayout;
